<template>
    <h4
        :class="
            twMerge(
                'whitespace-pre-line text-left text-[1rem] font-bold leading-[1.3] sm:text-[1.25rem] lg:text-[1.5rem]',
                locale === 'en' &&
                    'leading-[1.2] sm:tracking-[-0.01em] lg:leading-[1.3]',
                locale === 'ja' &&
                    'leading-[1.2] lg:leading-[1.3] lg:tracking-[-0.01em]',
                locale === 'ko' &&
                    'leading-[1.2] lg:leading-[1.3] lg:tracking-[-0.01em]',
                $attrs.class,
            )
        "
    >
        <slot />
    </h4>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { locale } = useI18n();
</script>
